import {
  FETCH_ALL_SERVICES_FAILURE,
  FETCH_ALL_SERVICES_REQUEST,
  FETCH_ALL_SERVICES_SUCCESS,
  RESET_SERVICE_DETAILS,
  SERVICE_ADD_FAILURE,
  SERVICE_ADD_REQUEST,
  SERVICE_ADD_SUCCESS,
  SERVICE_DELETE_FAILURE,
  SERVICE_DELETE_REQUEST,
  SERVICE_DELETE_SUCCESS,
  SERVICE_UPDATE_FAILURE,
  SERVICE_UPDATE_REQUEST,
  SERVICE_UPDATE_SUCCESS,
  SERVICE_VIEW_ALL_FAILURE,
  SERVICE_VIEW_ALL_REQUEST,
  SERVICE_VIEW_ALL_SUCCESS,
  SERVICE_VIEW_FAILURE,
  SERVICE_VIEW_REQUEST,
  SERVICE_VIEW_SUCCESS,
  UPDATE_SERVICE_APPROVAL_FAILURE,
  UPDATE_SERVICE_APPROVAL_REQUEST,
  UPDATE_SERVICE_APPROVAL_SUCCESS,
} from './ServiceType';

const initialState = {
  ServiceDetails: {
    data: [],
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
    loading: false,
    error: null,
  },
  Service: {
    data: [],
    loading: false,
    updateLoading: false,
    deleteLoading: false,
    error: null,
    success: ' ',
    approvalMessage: ' ',

    approvalLoading: false,
  },
};

const serviceReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SERVICE_VIEW_ALL_REQUEST:
    case FETCH_ALL_SERVICES_REQUEST:
      return {
        ...state,
        ServiceDetails: {
          ...state.ServiceDetails,
          loading: true,
          error: null,
          success: ' ',
        },
      };
    case SERVICE_ADD_REQUEST:
    case SERVICE_VIEW_REQUEST:
      console.log(' SERVICE_VIEW_REQUEST');
      return {
        ...state,
        Service: {
          ...state.Service,
          loading: true,
          error: null,
          deleteLoading: false,
          updateLoading: false,
          success: ' ',
        },
      };

    case SERVICE_DELETE_REQUEST:
      return {
        ...state,
        Service: {
          ...state.Service,
          loading: false,
          error: null,
          deleteLoading: true,
          updateLoading: false,
          success: ' ',
        },
      };
    case SERVICE_UPDATE_REQUEST:
      return {
        ...state,
        Service: {
          ...state.Service,
          loading: false,
          error: null,
          deleteLoading: false,
          updateLoading: true,
          success: ' ',
        },
      };
    case SERVICE_ADD_SUCCESS:
      return {
        ...state,
        Service: {
          ...state.Service,
          data: [],
          success: payload.message,
          loading: false,
          updateLoading: false,
          deleteLoading: false,
        },
      };

    case SERVICE_UPDATE_SUCCESS:
      return {
        ...state,
        Service: {
          ...state.Service,
          data: [],
          loading: false,
          updateLoading: false,
          success: payload.message || 'Service updated successfully!',
          deleteLoading: false,
          error: null,
        },
      };

    case SERVICE_VIEW_ALL_SUCCESS:
      return {
        ...state,
        ServiceDetails: {
          ...state.ServiceDetails,
          data: payload.data && payload.data.length > 0 ? payload.data : [],
          totalRecords: payload.totalRecords || 0,
          totalPages: payload.totalPages || 0,
          currentPage: payload.currentPage || 1,
          loading: false, // This should be inside ServiceDetails
          error: null,

          success: payload.message,
        },
      };

    case FETCH_ALL_SERVICES_SUCCESS:
      return {
        ...state,
        ServiceDetails: {
          ...state.ServiceDetails,
          data: payload.data && payload.data.length > 0 ? payload.data : [],
          totalRecords: payload.totalRecords || 0,
          totalPages: payload.totalPages || 0,
          currentPage: payload.currentPage || 1,
          loading: false, // This should be inside ServiceDetails
          error: null,
          success: payload.message,
        },
      };

    case SERVICE_VIEW_SUCCESS:
      return {
        ...state,
        Service: {
          ...state.Service,
          data: payload,
          loading: false,
          updateLoading: false,
          deleteLoading: false,
          error: null,
        },
      };

    case SERVICE_DELETE_SUCCESS:
      return {
        ...state,
        Service: {
          ...state.Service,
          data: [],
          loading: false,
          updateLoading: false,
          error: null,
          success: payload.message,
          deleteLoading: false,
        },
      };

    case SERVICE_ADD_FAILURE:
      console.log('add failure');

      return {
        ...state,
        Service: {
          ...state.Service,
          data: [],
          error: payload.message,
          updateLoading: false,
          deleteLoading: false,
          loading: false,
          success: ' ',
        },
      };
    case SERVICE_VIEW_FAILURE:
    case SERVICE_DELETE_FAILURE:
      return {
        ...state,
        Service: {
          ...state.Service,
          data: [],
          error: payload.message,
          loading: false,
          updateLoading: false,
          deleteLoading: false,
          success: ' ',
        },
      };
    case SERVICE_UPDATE_FAILURE:
      return {
        ...state,
        Service: {
          ...state.Service,
          data: [],
          error: payload,
          loading: false,
          updateLoading: false,
          deleteLoading: false,
          success: ' ',
        },
      };

    case SERVICE_VIEW_ALL_FAILURE:
    case FETCH_ALL_SERVICES_FAILURE:
      return {
        ...state,
        ServiceDetails: {
          ...state.ServiceDetails,
          data: [],
          error: payload,

          loading: false,
          success: ' ',
        },
      };
    case RESET_SERVICE_DETAILS:
      return {
        ...state,
        Service: {
          ...state.Service,

          loading: false,
          error: null,
          updateLoading: false,
          approvalLoading: false,
          deleteLoading: false,
          success: ' ',

          approvalMessage: ' ',
        },
        ServiceDetails: {
          ...state.ServiceDetails,

          totalRecords: 0,
          totalPages: 0,
          currentPage: 1,
          loading: false,
          error: null,
        },
      };
    case UPDATE_SERVICE_APPROVAL_REQUEST:
      return {
        ...state,
        Service: {
          ...state.Service,
          approvalLoading: true,

          approvalMessage: ' ',
          error: null,
        },
      };
    case UPDATE_SERVICE_APPROVAL_SUCCESS:
      console.log('serviceApproval success');
      return {
        ...state,
        Service: {
          ...state.Service,
          approvalLoading: false,

          approvalMessage: 'Service approval updated successfully!',
          success: 'Service approval updated successfully!',
          error: null,
        },
      };
    case UPDATE_SERVICE_APPROVAL_FAILURE:
      return {
        ...state,
        Service: {
          ...state.Service,
          approvalLoading: false,
          error: payload,

          approvalMessage: ' ',
        },
      };
    default:
      return state;
  }
};

export default serviceReducer;
